"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Schedule = function Schedule() {
  return _react2.default.createElement(
    "g",
    { id: "schedule" },
    _react2.default.createElement("path", {
      d: "M356,144 C327.9,115.8 289.8,100 250,100 L250,250 L144,356 C200.5,416.6 295.4,419.9 356,363.5 C416.6,307.1 419.9,212.1 363.5,151.5 C361.1,148.9 358.6,146.4 356,144 L356,144 Z M250,0 C111.9,0 0,111.9 0,250 C0,388.1 111.9,500 250,500 C388.1,500 500,388.1 500,250 C500,111.9 388.1,0 250,0 L250,0 L250,0 Z M250,450 C139.5,450 50,360.5 50,250 C50,139.5 139.5,50 250,50 C360.5,50 450,139.5 450,250 L450,250 C450,360.5 360.5,450 250,450 L250,450 Z",
      id: "Shape"
    })
  );
};

exports.default = Schedule;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Schedule.js
// module id = 2984
// module chunks = 4